<template>
	<div>
		<div v-if="article" class="page-title page-title-bg margin-bottom-30">
			<div class="container">
				<div class="row">
					<div class="col-xs-12 text-center">
						<span class="section-title-line"></span>
						<h1 class="reduced">{{ article.title }}</h1>
					</div>
				</div>
			</div>
		</div>

		<div v-if="article" class="articles-page padding-top-20 padding-bottom-20">
			<div class="container">
				<div>
					<vue-markdown v-if="article.text" class="articles-text">{{ article.text }}</vue-markdown>
				</div>

				<div v-if="article.cta_title" class="margin-bottom-50 margin-top-30 text-center">
					<div class="container">
						<h3>{{ article.cta_title }}</h3>
						<a
							v-if="article.cta_link && article.cta_value"
							:href="article.cta_link"
							class="button button-5 margin-top-20"
						>
							{{ article.cta_value }}
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VueMarkdown from 'vue-markdown-v2'
import AccountInfo from '@/mixins/AccountInfo'
import PageInfo from '@/mixins/PageInfo'
import ServiceHelper from '@/mixins/ServiceHelper'

export default {
	name: 'ArticlesDetail',
	components: {
		VueMarkdown,
	},
	mixins: [AccountInfo, PageInfo, ServiceHelper],
	props: {
		code: {
			type: String,
			required: true,
		},
		slug: {
			type: String,
			required: true,
		},
		topic: {
			type: String,
			required: false,
			default: '',
		},
	},
	data() {
		return {
			article: null,
			pageByCode: true,
			pageBySlug: true,
		}
	},
	created() {
		// Retrieve article from API
		this.loadData()
	},
	methods: {
		loadData() {
			// Get data
			axios
				.get('/articles/request-type/' + this.code + '/' + this.slug + '/' + this.topic, {
					params: this.loadAllParams,
				})
				.then((response) => {
					this.article = response.data.info
				})
				.catch((error) => {
					console.log(error)
				})
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/views/core/articles/ArticlesDetail.vue